import { gql } from '@apollo/client';

const SignupFederatedUserWithSubscription = gql`
  mutation signupFederatedUserWithSubscription($input: ResellerUserSignupInput!, $accessId: String!, $externalId: String) {
    signupFederatedUserWithSubscription(input: $input, accessId: $accessId, externalId: $externalId) {
      success
    }
  }
`;

export default SignupFederatedUserWithSubscription;
